<template>
  <div class="flex flex-col py-2 gap-2">
    <div v-for="i in 10" :key="i" class="rounded-xl bg-base p-2">
      <div class="flex flex-col justify-between gap-2">
        <div class="flex justify-between items-center w-full gap-2">
          <div class="flex items-center justify-center gap-2">
            <UserInterfaceGenericSkeleton
              height-class="h-6"
              width-class="w-24"
              rounded-class="rounded-lg"
            />
            <UserInterfaceGenericSkeleton
              height-class="h-2"
              width-class="w-2"
            />
          </div>
          <UserInterfaceGenericSkeleton height-class="h-2" width-class="w-6" />
        </div>
        <div class="flex justify-between items-center">
          <UserInterfaceGenericSkeleton
            height-class="h-10"
            width-class="w-10"
            rounded-class="rounded-lg"
          />
          <div class="flex flex-col w-full gap-1 px-2">
            <UserInterfaceGenericSkeleton
              height-class="h-4"
              idth-class="h-36"
              rounding-class="rounded-md"
            />
            <UserInterfaceGenericSkeleton
              height-class="h-4"
              width-class="w-24"
              rounding-class="rounded-md"
            />
          </div>
          <UserInterfaceGenericSkeleton
            height-class="h-6"
            width-class="w-6"
            rounding-class="rounded-sm"
          />
        </div>
      </div>
    </div>
  </div>
</template>
